import { Outlet } from "react-router-dom";

export function OpenLayout() {
  return (
    <div className="tw:h-screen tw:bg-background">
      <Outlet />
    </div>
  );
}
